<template>
    <div class="row">
        <!-- <div class="col-md-12">
            <h1 class="h4 mb-3 text-gray-800">
                {{ $t("Editar Concessão de Programa Social") }}
            </h1>
        </div>
        <load v-if="loading" /> -->
        <header-servico
            tipo="Concessão de Programa Social"
            :loading="loading"
            :familia="item.familia_id"
        />
        <load
            v-if="loading"
            message="Carregando Concessão de Programa Social da Família"
        />
        <div v-else class="col-md-12">
            <div class="row">
                <sidebar-servicos
                    active="programassociais"
                    :familia="item.familia_id"
                />
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <header-familia :item="item.familia" />
                        </div>
                    </div>
                    <b-card class="shadow" v-if="historicoStatus == false">
                        <template v-slot:default>
                            <form @submit.prevent="submit" ref="addItem">
                                <div class="row">
                                    <form-select
                                        v-model="item.pessoas"
                                        :multiple="true"
                                        label="Usuário(s)"
                                        :itens="pessoas"
                                        :required="true"
                                        :disabled="true"
                                    />

                                    <form-select
                                        v-model="item.programa_social_id"
                                        label="Programa Social"
                                        :itens="programas"
                                        :required="true"
                                        @input="setValor"
                                        :disabled="true"
                                        ajuda="Se o item que você procura não for
encontrado nas opções abaixo você deve cadastrar na página de gestão de Programas Sociais ou solicitar o cadastro a quem tem permissões para realizar a ação"
                                    />

                                    <form-calendar
                                        v-model="item.data_inicial"
                                        grid="2"
                                        label="Data Início"
                                        :required="true"
                                        :disabled="true"
                                    />

                                    <form-calendar
                                        v-model="item.data_final"
                                        grid="2"
                                        label="Data Final"
                                        :disabled="true"
                                    />

                                    <form-input
                                        v-model="item.valor"
                                        grid="4"
                                        inputGroup="true"
                                        btnText="R$"
                                        :type="'number'"
                                        label="Valor"
                                        :disabled="true"
                                    />

                                    <form-textarea-editor
                                        v-if="item.descricao != null"
                                        v-model="item.descricao"
                                        grid="12"
                                        label="Situação Identificada"
                                    />

                                    <form-select
                                        @change="verificarStatus"
                                        v-model="item.status"
                                        label="Status"
                                        grid="12"
                                        :itens="status"
                                    />
                                </div>

                                <div
                                    class="row pt-4 px-0 d-flex justify-content-end"
                                >
                                    <div class="col-auto px-2 text-right">
                                        <a
                                            class="router-link-exact-active active px-3"
                                            @click="historicoStatus = true"
                                        >
                                            <i class="fas fa-history"></i>
                                            Histórico de Status
                                        </a>

                                        <a
                                            class="btn btn-default"
                                            @click="getVoltar()"
                                        >
                                            <i class="mdi mdi-arrow-left" />
                                        </a>

                                        <a
                                            class="btn btn-primary"
                                            @click="$bvModal.show('modal-auditoria')"
                                            :title="$t('Auditoria')"
                                            v-b-tooltip.hover
                                        >
                                            <i class="mdi mdi-timeline-clock-outline mdi-16px" />
                                        </a>

                                        <a
                                        v-if="
                                            $store.state.user.role_details.name == 'Admin' ||
                                            $store.state.user.role_details.name == 'Gestor(a)' ||
                                            $store.state.user.id == item.user_id
                                            "
                                            title="Remanejar"
                                            class="btn btn-warning py-2"
                                            @click="$bvModal.show('modal-remanejar-servico')"
                                        >
                                            <i class="fas fa-exchange-alt mdi-18px" />
                                            {{ $t("Remanejar") }}
                                        </a>

                                        <b-button
                                            :title="$t('Visualizar e Imprimir')"
                                            :to="
                                                '/dashboard/programassociais/concessao/' +
                                                item.id +
                                                '/show'
                                            "
                                            class="py-1"
                                            size="sm"
                                            type="button"
                                            v-b-tooltip.hover
                                            variant="primary"
                                        >
                                            <i
                                                class="mdi mdi-printer mdi-18px"
                                            />
                                        </b-button>

                                        <button
                                            class="btn btn-success btn-submit"
                                            data-style="zoom-in"
                                            type="submit"
                                        >
                                            <i class="mdi mdi-content-save" />
                                            {{ $t("Salvar") }}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </b-card>

                    <b-card class="shadow" v-else>
                        <template v-slot:default>
                            <HistoricoStatus
                                @voltar="historicoStatus = false"
                                :id="item.id"
                                :familia="0"
                                :status="status_item"
                            />
                        </template>
                    </b-card>
                </div>
            </div>
            <status-historico
            :model="model"
            modulo="ProgramaSocial"
            titulo_modulo="CONCESSÃO DE PROGRAMA SOCIAL"
            :id="item.id"
            :status-anterior="statusAnterior"
            :status-atual="statusAtual"
            :status="status_item"
            @submit="submit"
            />
            <ModalRemanejarServico
                :servico_id="item.id"
                :tecnico_id="item.user.tecnico.id"
                servico="programassociais"
            />
            <ModalAuditoria
                servico="programassociais"
                :servico_id="item.id"
            />
        </div>
    </div>
</template>

<script>
import ModalRemanejarServico from "../../../../../../resources/js/dashboard/components/widgets/ModalRemanejarServico";
import HistoricoStatus from "./HistoricoStatus";
import ModalAuditoria from "../../../../../../resources/js/dashboard/components/widgets/ModalAuditoria";
export default {
    name: "Edit",
    components: {
        HistoricoStatus,
        ModalRemanejarServico,
        ModalAuditoria
    },
    data() {
        return {
            loading: true,
            item: {
                descricao: null,
                valor: "",
                familia: {
                    familiares: [],
                },
                user: {tecnico: {}}
            },
            status: {},
            status_item: [],
            statusAtual: "",
            statusAnterior: "",
            programas: {},
            model: "ProgramaSocialFamilia",
            historicoStatus: false,
            rotaanterior: null,
        };
    },
    computed: {
        pessoas() {
            let pessoas = this.item.familia.familiares ?? [];
            pessoas = pessoas.filter((elem) => {
                return elem.estado_cadastral_cadunico <= 3;
            });
            const map = pessoas.map((elem) => ({
                id: elem.id,
                value:
                    elem.posicao_familiar == 1
                        ? "<b>RF - </b> " +
                          elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>"
                        : elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>",
            }));
            return map;
        },
    },
    mounted() {
        this.getStatus();
        this.getProgramasSociais();
        this.getItem();
        this.getStatusFinais();
    },
    methods: {
        getItem() {
            this.loading = true;
            axios
                .get(
                    `api/dashboard/programasocial/beneficiarios/` +
                        this.$route.params.id
                )
                .then((response) => {
                    this.item = response.data.data;
                    this.statusAnterior = this.item.status;
                })
                .finally(() => (this.loading = false));
        },
        getProgramasSociais() {
            axios.get(`api/dashboard/get/programassociais`).then((response) => {
                this.programas = response.data;
            });
        },
        setValor(value) {
            this.programas.filter((item) => {
                if (value == item.id && item.valor != null) {
                    this.item.valor = item.valor;
                } else {
                    this.item.valor = "";
                }
            });
        },
        submit() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .put(
                    "api/dashboard/programasocial/beneficiarios/" +
                        this.item.id,
                    this.item
                )
                .then((response) => {
                    ladda.stop();
                    this.getItem();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                });
        },
        getStatus() {
            axios
                .get(`api/dashboard/status/concessaoprograma`)
                .then((response) => {
                    this.status = response.data;
                });
        },
        verificarStatus(status) {
            this.statusAtual = status;

            if (this.statusAtual != this.statusAnterior) {
                const result = this.status_item.filter(
                    (item) => item.id == status
                );
                if (result[0].final == 1) {
                    //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
                    this.$bvModal.show("status-historico-" + this.model);
                }
            }
        },
        getStatusFinais() {
            axios
                .post(`api/dashboard/get/status/finais`, {
                    model: this.model,
                    module: "ProgramaSocial",
                })
                .then((response) => {
                    this.status_item = response.data;
                });
        },
        getVoltar() {
            this.$route.query.rotaanterior == "familia"
                ? this.$router.push(
                      "/dashboard/programassociais/beneficiarios/" +
                          this.item.familia.id +
                          "?familia_id=" +
                          this.item.familia.id
                  )
                : this.$router.push(
                      "/dashboard/programassociais/edit/" +
                          this.item.programa.id
                  );
        },
    },
};
</script>

<style></style>
